module.exports = __webpack_public_path__ + "img/pic-01.0841c6e0.png";